'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('user-prime', {
    url: '/user/prime/?tab&clinicId&year&month',
    templateUrl: '/views/user-prime.html',
    controller: 'UserPrimeCtrl',
    reloadOnSearch: false,
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('Prime - Opencare');
      },
      user: function(CurrentUser) {
        return CurrentUser.waitForUserLoad();
      },
    },
  });
});

angular.module('ClinicApp').controller('UserPrimeCtrl', function($scope, $state, $stateParams, $timeout, CurrentUser) {
  $scope.preloadData = {
    clinicId: $stateParams.clinicId,
    year: parseInt($stateParams.year, 10) || undefined,
    month: parseInt($stateParams.month, 10) || undefined,
  };
  $scope.user = CurrentUser.getUser();
  $scope.userClinics = CurrentUser.getClinics();

  $scope.setTab = (tab) => {
    tab = tab || 'appointments';

    angular.element(`ul.nav a[aria-controls="${tab}"]`).tab('show');

    $state.go('.', {
      tab,
    }, {
      location: 'replace',
    });

    OpencareAnalytics.trackPageView({
      pageType: OpencareAnalytics.pageTypes.INVOICE_MANAGER,
      pageName: `Invoice Manager - ${tab}`,
      section: tab,
      name: 'invoice-manager',
      userId: $scope.user.id,
      content: {
        view: 'practice',
        is_real_practice: String(!CurrentUser.isImpersonated()),
      },
    });
  };

  $timeout(() => $scope.setTab($stateParams.tab));
});
